import React from 'react';
import { motion } from 'framer-motion';

const GlassCard = ({ children, className = '', hover = true, glow = false, ...props }) => {
  return (
    <motion.div
      className={`
        relative backdrop-blur-xl bg-black/70 border border-green-500/30 rounded-2xl
        shadow-2xl shadow-green-500/20
        ${glow ? 'shadow-green-400/30 ring-1 ring-green-400/40' : ''}
        ${hover ? 'hover:bg-black/80 hover:border-green-400/50 hover:shadow-green-400/30 hover:shadow-3xl' : ''}
        transition-all duration-500 ease-out
        ${className}
      `}
      whileHover={hover ? { 
        scale: 1.02, 
        boxShadow: '0 25px 50px -12px rgba(0,255,65,0.3)' 
      } : {}}
      transition={{ type: "spring", stiffness: 300, damping: 30 }}
      {...props}
    >
      {/* Glow effect */}
      <div className="absolute -inset-1 bg-gradient-to-r from-green-400/20 via-green-500/20 to-red-400/10 rounded-2xl blur opacity-30 group-hover:opacity-60 transition duration-1000" />
      
      {/* Content */}
      <div className="relative z-10 h-full">
        {children}
      </div>
      
      {/* Inner glow */}
      <div className="absolute inset-0 rounded-2xl bg-gradient-to-br from-green-500/5 to-transparent pointer-events-none" />
    </motion.div>
  );
};

export default GlassCard;